<template>
  <v-container>
    <article>
      <div
        v-for="(how, index) in props.howTo"
        :key="index"
        itemscope
        itemtype="https://schema.org/HowTo"
        class="howTo-item v-sheet v-sheet--outlined"
      >
        <v-row class="align-center" @click="toggleAnswer(index)">
          <v-col class="py-1">
            <div itemprop="name" class="font-weight-bold howTo-question-title">
              {{ how.question?.name }}
            </div>
            <div itemprop="description">{{ how.question?.description }}</div>
          </v-col>
          <v-col class="text-right py-1" cols="auto">
            <v-icon :icon="activeIndex === index ? '$chevronUp' : '$chevronDown'"></v-icon>
          </v-col>
        </v-row>

        <div :class="activeIndex === index ? 'd-block howTo-answer' : 'd-none howTo-answer'">
          <ol>
            <li
              v-for="(step, k) in how.steps"
              :key="k"
              itemprop="step"
              itemscope
              itemtype="https://schema.org/HowToStep"
            >
              <span :itemprop="step?.name ? 'name' : 'text'" :class="{ 'font-weight-bold': step?.name }">
                {{ step?.name || step?.text }}
              </span>
              <div v-if="step?.name" itemprop="text">{{ step?.text }}</div>
            </li>
          </ol>
        </div>
      </div>
    </article>
  </v-container>
</template>
<script setup>
const props = defineProps({
  howTo: {
    type: Array,
    default: () => [],
  },
});

const activeIndex = ref(null);

const toggleAnswer = index => {
  activeIndex.value = activeIndex.value === index ? null : index;
};
</script>
<style scoped>
.howTo-item {
  cursor: pointer;
  padding: 16px;
  border: 0.2px solid rgba(0, 0, 0, 0.12);
  border-radius: 4px;
  box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14),
    0px 1px 5px 0px rgba(0, 0, 0, 0.12);
}

.howTo-answer {
  margin-top: 0.5rem;
}
.howTo-question-title {
  font-size: 1rem !important;
}
.howTo-item:hover {
  opacity: 0.9;
}
.howTo-article {
  clear: both;
}
</style>
